import {ref} from "vue";

export const useGetShipmentStores = () => {
    const items = ref(null);

    const getShipmentStores = async (updateShipmentId) => {
        let url = '/shipments/shipment-stores/' + updateShipmentId;

        return await axios.get(url).then(({data}) => {
            items.value = data;
            return data;
        });
    }

    return { getShipmentStores, items };
}
